import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelopePeak = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.4 6.53333L8 10L13.6 6.53333M2.26667 6.26667L8 2.66667L13.7333 6.26667V12.1333C13.7333 12.2734 13.7057 12.4121 13.6521 12.5415C13.5985 12.6709 13.52 12.7885 13.4209 12.8876C13.3219 12.9866 13.2043 13.0652 13.0749 13.1188C12.9454 13.1724 12.8067 13.2 12.6667 13.2H3.33333C3.19326 13.2 3.05455 13.1724 2.92514 13.1188C2.79572 13.0652 2.67814 12.9866 2.57909 12.8876C2.48004 12.7885 2.40147 12.6709 2.34786 12.5415C2.29426 12.4121 2.26667 12.2734 2.26667 12.1333V6.26667Z",
		stroke: "currentColor",
		strokeWidth: 1.33,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEnvelopePeak;
